<template>
	<ul class="list-unstyled">
		<li>{{spellLevel|ordinal}}</li>
		<planned-level-spells-list-item v-for="n in spellsKnown" :key="`spells-known-list-${level}-${spellLevel}-${n-1}`" :level="level" :spellLevel="spellLevel" :listIndex="n-1">
		</planned-level-spells-list-item>
	</ul>
</template>

<script>
import PlannedLevelSpellsListItem from '@/components/planning/PlannedLevelSpellsListItem.vue'

export default {
	components: {
		PlannedLevelSpellsListItem,
	},
	props: [
		'level',
		'spellLevel',
		'spellsKnown',
	],
	computed: {
		spellsList: function() {
			return this.$store.state.Character.Levels[this.level].Spells.List[this.spellLevel]
		},
	},
	watch: {
		spellsList: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].Spells.List[${this.spellLevel}]`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>

</style>